exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles-split-line-2WMaC{background-color:#000}.styles-split-line-vertical-1V4q6{width:1px;height:100%}.styles-split-line-horizontal-1Jqbm{width:100%;height:1px}", ""]);

// Exports
exports.locals = {
	"split-line": "styles-split-line-2WMaC",
	"split-line-vertical": "styles-split-line-vertical-1V4q6",
	"split-line-horizontal": "styles-split-line-horizontal-1Jqbm"
};